import React from 'react';
import {string, bool, oneOfType, node, element} from 'prop-types';
import classnames from 'classnames';
import styles from './MobileNavDrawer.scss';

const DURATION_SCROLL_DATA_RESET = 250;
const PIXELS_SCROLL_DISTANCE = 50;
const PIXELS_FORCE_APPEAR = 100;

export default class MobileNavDrawer extends React.Component {

    constructor() {
        super();

        this.state = {
            isOpen: true
        };

        this.scroll = {
            last: 0,
            distance: 0
        };
        this.rafTick = null;
        this.resetTimeout = null;

        this.onScroll = this.onScroll.bind(this);
    }

    componentDidMount() {
        document.addEventListener('scroll', this.onScroll);
    }

    componentWillUnmount() {
        document.removeEventListener('scroll', this.onScroll);
    }

    getScrollY() {
        return Math.round(window.pageYOffset);
    }

    resetScrollData() {
        this.scroll = {
            last: 0,
            distance: 0
        };
    }

    onScroll() {
        if (!this.rafTick && !this.props.disabled) {
            this.rafTick = requestAnimationFrame(() => {
                const currentScroll = this.getScrollY();
                const scrollData = this.scroll;

                if (scrollData.last === 0) {
                    scrollData.last = currentScroll;
                }

                // Number of pixels scrolled.
                const scrollDelta = scrollData.last - currentScroll;
                // Total distance scrolled since the first scroll event has been captured.
                const scrollDistance = scrollData.distance += scrollDelta;
                const forceOpen = currentScroll <= PIXELS_FORCE_APPEAR;
                const shouldClose = !forceOpen && scrollDistance < -PIXELS_SCROLL_DISTANCE;
                const shouldOpen = scrollDistance > PIXELS_SCROLL_DISTANCE || forceOpen;
                if (!this.state.isOpen && shouldOpen) {
                    this.setState({
                        isOpen: true
                    });
                } else if (this.state.isOpen && shouldClose && !shouldOpen) {
                    this.setState({
                        isOpen: false
                    });
                }

                scrollData.last = currentScroll;
                this.rafTick = null;

                /**
                 * We mimick a scroll start event by reseting the scroll state if a scroll event hasn't been captured
                 * for a specified amount of time.
                 */
                clearTimeout(this.resetTimeout);
                this.resetTimeout = setTimeout(() => this.resetScrollData(), DURATION_SCROLL_DATA_RESET);
            });
        }
    }

    render() {
        const {isOpen} = this.state;
        const classes = classnames(this.props.className, {
            [styles.slideIn]: isOpen,
            [styles.slideOut]: !isOpen
        });

        return (
            <div className={classes}>
                {this.props.children}
            </div>
        );
    }
}

MobileNavDrawer.propTypes = {
    className: string,
    disabled: bool,
    children: oneOfType([element, node])
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavDrawer/MobileNavDrawer.jsx